/* eslint-disable */
import React from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';

// components
import { ModalBase, Table } from '../../common/components';

function formatDate(d) { return moment(d).format('MM/DD/YYYY hh:mm A'); }

function SubTable({ data }) {
  const schema = {
    cols: [
      { header: 'Pattern', field: 'pattern' },
      { header: 'Created', field: 'created', formatter: formatDate },
      { header: 'Last Updated', field: 'updated', formatter: formatDate },
    ],
  };

  return (
    <Table
      className="table table-bordered mb-0"
      schema={schema}
      data={data.patterns || []}
    />
  );

}

function PatternsModal() {
  const dispatch = useDispatch();
  const {
    carriers,
    modals: { patternsModal },
    rts: { patterns },
  } = useSelector(store => store);
  const { familyID } = useSelector(store => store.rts.filters);

  // formatting functions for table cells
  function formatCarrierID(cid) { return carriers[cid]; }
  function formatPatterns(patternsArray) { return patternsArray.length }
  function formatFamilyID(fid, isActive) {
    return (
      <>
        <button className={`btn btn-sm btn-outline-success me-3 ${isActive ? 'active' : ''}`}>
          <FontAwesomeIcon icon={faCheck} />
        </button>
        {fid}
      </>
    );
  }

  // table cell click handler
  function setFamilyIDFilter(id) {
    dispatch({ type: 'SET_RTS_FILTER', payload: { familyID: id } });
    dispatch({ type: 'CLOSE_MODAL', modal: 'patternsModal' });
  }

  function isFileFamilyActiveFilter(id) {
    if (String(familyID) === String(id)) return true;
    return false;
  }

  return (
    <ModalBase
      title="RTS File Families and Patterns - Select Filter"
      isOpen={patternsModal}
      closeModalAction={() => dispatch({ type: 'CLOSE_MODAL', modal: 'patternsModal' })}
      staticWidth="90%"
      allowOverlayClickClose
    >
      <div className="p-3">
        <Table
          className="table table-striped"
          schema={{
            cols: [
              {
                header: 'File Family ID',
                field: 'familyID',
                cellClasses: '',
                clickHandler: setFamilyIDFilter,
                title: 'Click to select as the filter',
                formatter: formatFamilyID,
                conditionalCheck: isFileFamilyActiveFilter,
              },
              { header: 'Carrier', field: 'carrierID', formatter: formatCarrierID },
              { header: 'Family Name', field: 'name' },
              { header: 'Created', field: 'created', formatter: formatDate },
              { header: 'Last Updated', field: 'updated', formatter: formatDate },
              { openSubComponent: true, header: 'Patterns', field: 'patterns', cellClasses: 'text-end', formatter: formatPatterns },
            ],
            subComponentContainerClasses: 'bg-primary bg-opacity-10',
            subComponent: (data) => <SubTable data={data} />,
          }}
          data={patterns}
        />
      </div>
    </ModalBase>
  );
}

export default PatternsModal;
